/**
 * Sello de valor no verificado.
 *
 * En el mundo visual del cotizador el ámbar discontinuo significa una sola cosa —lo
 * que todavía no está medido ni confirmado— y no se usa para nada más. Vive en su
 * propio archivo porque tiene que cruzar de la aplicación a los documentos: un
 * renglón sin precio que en pantalla dice «por definir» y en la propuesta impresa
 * aparece como $0 es justamente la mentira que este sello existe para impedir.
 *
 * Regla dura de PRODUCT.md: los supuestos se marcan como supuestos, en el sistema
 * y en el documento.
 */
export default function Sello({ children = 'Por definir' }) {
  return <span className="sello">{children}</span>
}
